import { render } from "./addRIIForm.vue?vue&type=template&id=f4b77302&scoped=true"
import script from "./addRIIForm.vue?vue&type=script&lang=js"
export * from "./addRIIForm.vue?vue&type=script&lang=js"

import "./addRIIForm.vue?vue&type=style&index=0&id=f4b77302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b77302"]])

export default __exports__